import {
  AUDIT_LOG_TARGET_TYPES,
  IAuditLog,
  IAuthAuditLog,
  IAuthAuditLogData,
  IGetAuditLogsListPayload,
} from 'api/auditLogs/types';
import axiosInstance, { axiosAuthInstance } from 'api/base';
import { normalizePageData } from 'utils/commonNormalizer';
import { normalizeSearchFiltersPayload } from 'utils/filters';
import { IAllPageFilters, IPageType, TObject } from 'utils/types';

import { normalizeAuditLogs, normalizeAuthAuditLogs } from './normalizers';

const auditLogsAPI = {
  async getAuditLogs({
    filters,
    targetId,
    targetType,
  }: IGetAuditLogsListPayload): Promise<IPageType<IAuditLog>> {
    const normalizedFilter = normalizeSearchFiltersPayload(filters);

    const serviceInstance =
      targetType === AUDIT_LOG_TARGET_TYPES.USER ||
      targetType === AUDIT_LOG_TARGET_TYPES.ROLE
        ? axiosAuthInstance
        : axiosInstance;

    const response = await serviceInstance.get(`audit-logs/${targetType}/${targetId}`, {
      params: normalizedFilter,
    });

    return normalizePageData<TObject, IAuditLog>(
      response?.data,
      normalizeAuditLogs,
      JSON.stringify(filters.search),
    );
  },

  async getUsersAuditLogs(filters: IAllPageFilters): Promise<IPageType<IAuditLog>> {
    const normalizedFilter = normalizeSearchFiltersPayload(filters);

    const { data } = await axiosInstance.get('audit-logs', {
      params: normalizedFilter,
    });

    return normalizePageData<TObject, IAuditLog>(
      data,
      normalizeAuditLogs,
      JSON.stringify(filters.search),
    );
  },

  async getAllAuthAudit(filters: IAllPageFilters): Promise<IPageType<IAuthAuditLog>> {
    const normalizedFilter = normalizeSearchFiltersPayload(filters);

    const response = await axiosAuthInstance.get(`users/activity`, {
      params: normalizedFilter,
    });

    return normalizePageData<IAuthAuditLogData, IAuthAuditLog>(
      response.data,
      normalizeAuthAuditLogs,
      JSON.stringify(filters.search),
    );
  },
};

export default auditLogsAPI;
